export const storageProviders = {
    IPFS: "ipfs",
    FILECOIN: "filecoin",
};

export const storageTypes = [
    { label: "IPFS", id: storageProviders.IPFS },
    { label: "Filecoin", id: storageProviders.FILECOIN },
];
